var CAMPAIGN_ACTIVE = false;

var prebuiltFooterCampaigns = [
    {
        cookieName : 'akvw77js',
        campaignName: "matching-challenge",
        campaignUrl : 'https://aclj.org/aclj/tax-deductible-donations-doubled-today',
        skipUTM: true,
        checkMethod : isMatchingChallenge,
        expirationDateMethod: getMatchingTTLDate,
        images: [
            //{ checkMethod: isYearEnd, image: "https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/year-end-matching-challenge-2.jpg" },
            { checkMethod: isDeadline, image: "https://s3.amazonaws.com/acljdigital/ACLJ+Site+Images/ACLJ/matching_deadline_footer.png" },
            { image: "https://s3.amazonaws.com/acljdigital/ACLJ+Site+Images/ACLJ/matching_footer.png" }
        ]
    },
    // {
    //     cookieName : 'c2816gdr',
    //     campaignName : 'complete-profile',
    //     campaignUrl : 'https://aclj.org/profile',
    //     checkMethod: memberLoggedInWithIncompleteAddress,
    //     image : 'https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/Profile_popup_2.0.jpg'
    // }
]

var prebuiltPopupCampaigns = [
    {
        cookieName : 'akvw77js',
        campaignName: "matching-challenge",
        campaignUrl : 'https://aclj.org/aclj/tax-deductible-donations-doubled-today',
        skipUTM: true,
        checkMethod : isMatchingChallenge,
        expirationDateMethod : getMatchingTTLDate,
        images: [
            { checkMethod: isYearEnd, image: "https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/year-end-matching-challenge-2.jpg" },
            { checkMethod: isDeadline, image: "https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/Matching_Popup_Deadline.png" },
            { image: "https://71e73428c98d2e64fd6b-596a7347bb8d75314ef5b080382defe2.ssl.cf2.rackcdn.com/popup/Matching_Popup_Doubled.png" }
        ]
    },
    {
        cookieName : 'gnp8361p',
        campaignName : 'revenge-of-the-taliban-ad',
        campaignUrl : 'https://aclj.org/taliban',
        skipUTM: false,
        checkMethod: function(){
            // Run through end of October
            let now = new Date();
            let november = new Date(2021,10,1)
            let beforeNov = now < november;
            let onPage = window.location.pathname === "/taliban" // Check that they are not already on this page
            return beforeNov && !onPage;
        },
        image : 'https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/Revenge_Taliban_Popup.jpg'
    },
    {
        cookieName : 'c2816gdr',
        campaignName : 'complete-profile',
        campaignUrl : 'https://aclj.org/profile',
        skipUTM: false,
        checkMethod: memberLoggedInWithIncompleteAddress,
        image : 'https://7676076fde29cb34e26d-759f611b127203e9f2a0021aa1b7da05.ssl.cf2.rackcdn.com/Profile_popup_2.0.jpg'
    }
]

var runCampaign = function(config, type){
    if(window.disableInfoCampaign) return // The push notification prompt will block this if it needs to be shown so both aren't displayed at the same time
    if(mobileCheck() || CAMPAIGN_ACTIVE) return false;
	if(typeof config === 'object' && ((typeof config.checkMethod === 'function' && config.checkMethod()) || (typeof config.checkMethod === 'undefined'))){
		var imageURL = getCampaignImage(config);
		if(typeof config.cookieName === 'string' && config.cookieName !== '' && typeof config.campaignName === 'string' && config.campaignName !== '' && imageURL !== ''){
			if(cookies.getItem(config.cookieName) !== config.campaignName){
				CAMPAIGN_ACTIVE = true;
                //PRELOAD IMAGE
                var preloadImage = new Image();
                preloadImage.src = imageURL;
                preloadImage.onload = (function(config, imageURL, type){
                    return function(){
                        if(type === 'footer')
                            displayFooterAd(config.campaignName, config.campaignUrl, imageURL, config.skipUTM);
                        else
                            displayPopupAd(config.campaignName, config.campaignUrl, imageURL, config.skipUTM);
                        //SET COOKIE
                        var d = (typeof config.expirationDateMethod === 'function')? config.expirationDateMethod() : getTTLDate(30);
                        cookies.setItem(config.cookieName, config.campaignName, type === 'footer'? null : d.toUTCString(), '/', null, true, "Strict", false);
                        //SEND DISPLAYED ANALYTICS EVENT
                        dataLayer.push({'event': 'Info Campaign Displayed', 'info_campaign_name': config.campaignName})
                    }
                })(config, imageURL, type);
				return true; //Indicate that campaign is running
			}
		}
	}
	return false;
}

var displayFooterAd = function(campaignName, campaignUrl, imageURL, skipUTM){
    var $img = $('#FooterCampaign img.img-responsive');
    var $link = $('#FooterCampaign a');
    $img.prop('src', imageURL);
    $link.prop('href', formatCampaignUrl('footerad',{campaignUrl:campaignUrl, campaignName: campaignName, skipUTM: skipUTM}))
    //Click analytics
    $link.on('click', createCampaignClickTracker(campaignName));
    $('#FooterCampaign').show();
}

var displayPopupAd = function(campaignName, campaignUrl, imageURL, skipUTM){
    campaignUrl = formatCampaignUrl('sitePopup', {campaignUrl:campaignUrl, campaignName: campaignName, skipUTM: skipUTM});
    var content = '<div><style>#infoContainer{max-width: 377px;max-height: 377px;padding-right: 0;padding-left: 0;position: relative;display: block;text-align: center;text-decoration: none;}</style><a id="infoContainer" href="' + campaignUrl + '"><img class="img-responsive" src="' + imageURL + '"></a></div>';
    //CLICK ANALYTICS
    $('body').on('click', '#infoContainer', createCampaignClickTracker(campaignName));
    $.fancybox.open({
        maxWidth	: 377,
        maxHeight	: 377,
        width		: '80%',
        height		: 'auto',
        fitToView	: false,
        autoSize	: false,
        closeClick	: false,
        openEffect	: 'fade',
        closeEffect	: 'fade',
        padding 	: 0,
        margin		: 0,
        scrolling	: 'no',
        content		: content
    });
}

//Run this as a jquery callback for an a tag
var createCampaignClickTracker = function(campaignName){
    if(typeof campaignName !== 'string' || campaignName === "") return;
    return function(e){
        e.preventDefault();
        dataLayer.push({'event': 'Info Campaign Click', "info_campaign_name": campaignName})
        window.location.href = $(this).attr('href');
    }
}

var runPrebuiltCampaigns = function(type){
    var campaigns = (type && type === 'footer')? prebuiltFooterCampaigns : prebuiltPopupCampaigns;
    for(var i = 0; i < campaigns.length; i++){
        if(runCampaign(campaigns[i], type)) break;
    }
}

$('#FooterCampaign .closeCampaign').on('click', function(){
	$('#FooterCampaign').hide();
})